import store from "../app/store";
import {createAction} from "@reduxjs/toolkit";
import {getSortAndFilterQueryString} from "../view/urlService";
import {securedFetch} from "../auth/authService";
import {AIML_RESULTS_API} from "../vars";
import fileSaver from 'file-saver';
import {ACTION_RESULTS_CHANGED, ACTION_RESULTS_CHANGED_GET_ALL_RESULTS} from "./MlDetectionPageReducer";

// export function listPageable(pageNumber, pageSize) {
//     return securedFetch(`${CONFIG_ACTION_ANOMALY_API}/analysis/results/page`, {
//         mode: "login",
//         p_page: pageNumber,
//         p_size: pageSize,
//     })
//         .then(response => response.json())
//         .then(data => {
//             store.dispatch(createAction(ACTION_RESULTS_CHANGED)({results: data.page}));
//             return {users: data.page, totalPages: data.total, totalRecords: data.records, error: null}
//         })
//         .catch(error => {
//             store.dispatch(createAction(ACTION_RESULTS_CHANGED)({results: []}));
//             return {users: [], totalPages: 0, totalRecords: 0, error: error?.message || 'Unable to load ML results'};
//         });

// }

export function listPageable(pageNumber, pageSize) {
    let queryString = getSortAndFilterQueryString(pageNumber, pageSize);
    if (!queryString.includes('s_date')){
        queryString = queryString+'&s_date=desc';
    }
        
    return securedFetch(`${AIML_RESULTS_API}/page?${queryString}`).then(response => response.json()).then(data => {
        store.dispatch(createAction(ACTION_RESULTS_CHANGED)({results: data.page}));
        return {users: data.page, totalPages: data.total, totalRecords: data.records}
    });

}

// export function list() {
//     return securedFetch(`${CONFIG_ACTION_ANOMALY_API}/analysis/results`, {
//         mode: "login",
//     })
//         .then(response => response.json())
//         .then(data => {
//             store.dispatch(createAction(ACTION_RESULTS_CHANGED_GET_ALL_RESULTS)({ allResults: data }));
//             return data;
//         })
//         .catch(() => {
//             store.dispatch(createAction(ACTION_RESULTS_CHANGED_GET_ALL_RESULTS)({ allResults: [] }));
//             return [];
//         });

// }

export function list() {
    return securedFetch(`${AIML_RESULTS_API}`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_RESULTS_CHANGED_GET_ALL_RESULTS)({ allResults: data }));
            return data;
        });

}

// export async function getAvailableDates() {
//     return list().then((data) => {
//         const dates = data
//             .map((item) => item?.date)
//             .filter(Boolean)
//             .filter((value, index, self) => self.indexOf(value) === index);
//         return dates;
//     });
// }

export async function getAvailableDates() {
    return securedFetch(`${AIML_RESULTS_API}/dates`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_RESULTS_CHANGED_GET_ALL_RESULTS)({ allResults: data }));
            return data;
        });
}

//Added by Octopus DevTeam july 18-2022
// export async function exportMachineLearningData(){
//     const data = await list();
//     const rows = data.map((result) => ({
//         Date: result.date || "",
//         "IP Address": result.ip || "",
//         User: result.usr || "",
//         Detail: result.note || "",
//         Result: result.detectionResults || "",
//     }));
//     const headers = ["Date", "IP Address", "User", "Detail", "Result"];
//     const csv = [
//         headers.join(","),
//         ...rows.map((row) =>
//             headers.map((header) => JSON.stringify(row[header] ?? "")).join(",")
//         ),
//     ].join("\n");
//     const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
//     fileSaver.saveAs(blob, "MachineLearningResults.csv");
// }

export async function exportMachineLearningData(pageNumber, pageSize){
    let filename="MachineLearningResults.xlsx";
    const token = sessionStorage.getItem('access_token');
    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);
    await fetch(`${AIML_RESULTS_API}/export-to-excel?${queryString}`,{
 
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        
        body: JSON.stringify({
            filename: filename
        })

    }).then(async (res)=>{
        const responseJson = await res.blob();
        fileSaver.saveAs(responseJson, filename);
    });
}
